import React, { useEffect, useState } from "react";
import api from "../../services/api";
import auth from "../../services/auth";
import parse from 'html-react-parser';

function Processos()
{

    const [listProcessos, setListProcessos] = useState([])
    const [processo, setProcesso] = useState({});
    const [viewProcesso, setViewProcesso] = useState(false)
    useEffect(()=>{
        getProcessos();
        
    },[]);




    
    const getProcessos = async ()=>
    {
        var data = new FormData();
        var myHeaders = new Headers();

        myHeaders.append("Cookie", "PHPSESSID=o45tbtoifviej7f4mv78ktuqlr");
        myHeaders.append('Content-Type', 'Application/json');
        data.append('action', 'processos');
        data.append('cpf_cliente', auth.getUser().cpf);

        api.post('wp-admin/admin-ajax.php', data, {
            headers: myHeaders
        }).then(function(response)
        {
            setListProcessos(response.data)
        }).catch(function(error)
        {

        })
    }


    const vizualizar = (processo = {})=>{
        setProcesso(processo)
        setViewProcesso(true);
    }


    const getProcesso = ()=>{

        let processo_dados:any = {};

        processo_dados = processo;

        return processo_dados.movimentacoes

    }

    const voltar = ()=>{
        setProcesso({})
        setViewProcesso(false)
    }

    return (
        <div>
            {viewProcesso == false ?
            <table className="table table-dark">
                <thead>
                    <tr>
                        <th scope="col">Nº Processo</th>
                        <th scope="col">Advogado</th>
                        <th scope="col">Dados</th>
                    </tr>
                </thead>
                <tbody>
                    {listProcessos.map((processo, index)=>(
                        <tr key={index}>
                            <td>{processo["numero_processo"]}</td>
                            <td>{processo["advogado"]}</td>
                            <td><button className="btn btn-primary" onClick={()=>vizualizar(processo)}>Vizualizar</button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            :
            <div>
                <button className="btn btn-primary" onClick={voltar}>Voltar</button><br></br><br></br>
                {parse(getProcesso())}
            </div>
            }
        </div>
    )
}

export default Processos;